import { axiosInstance } from "./axios";

export const GetCountParticipant = async() => {
  return await axiosInstance
    .get("/corporations/participants")
    .then(res =>  res.data.data)
    .catch((err) => console.log("e", err));
};
